import { makeStyles } from '@material-ui/core'

const styles = makeStyles(() => ({
  rootCard: {
    width: '100%',
  },
}))

export default styles
